<template>

    <CCard>

        <CCardHeader>
            Перенаправление доставки
            <RestaurantTableOrderBadge />
        </CCardHeader>

        <CCardBody>
            
            <slot name="tabs"></slot>

            <CForm>
                <div class="overflow-hidden border border-gray-300 rounded-md">

                    <div class="flex items-center bg-gray-100">
                        <div class="w-2/5 py-2 font-bold pl-2">Если заказ из башни</div>
                        <div class="w-2/5 py-2 font-bold">То везем в башню</div>
                        <div class="w-1/5 py-2 font-bold"></div>
                    </div>

                    <div
                        v-for="(item, index) in list"
                        :key="index"
                        class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
                    >
                        <div class="w-100 flex items-center">
                            <div class="w-2/5">
                                <CSelect
                                    :value.sync="item.address_id_from"
                                    inline
                                    :options="formattedAddresses"

                                    placeholder="Башня"
                                    class="m-0 mr-2" />
                            </div>
                            <div class="w-2/5">
                                <CSelect
                                    :value.sync="item.address_id_to"
                                    inline
                                    :options="formattedAddresses"
                                    placeholder="Башня"
                                    class="m-0 mr-2" />
                            </div>
                            <div class="w-1/5">
                                <CButton
                                    variant="outline"
                                    color="danger"
                                    class="mr-3"
                                    @click="remove(index)"
                                >Удалить</CButton>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 p-2">
                        <CButton
                            variant="outline"
                            color="success"
                            class="mr-3"
                            @click="add"
                        >Добавить</CButton>
                    </div>

                </div>
            </CForm>

        </CCardBody>

        <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="save"
            >Сохранить</CButton>
        </CCardFooter>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
            
    </CCard>

</template>

<script>
    export default {

        name: 'Delivery',

        components: {
        },

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
        },
  
        data () {
            return {
                list: [],
                deleted: [],
                addresses: [],
                isPending: false
            }
        },

        computed: {
            formattedAddresses() {
                return this.addresses.map(item => ({
                    label: item.name,
                    value: item.id,
                }));
            }
        },

        async mounted() {
            this.addresses = (await this.axios.get('/address')).data;
            await this.fetch();
        },
        
        methods: {
            async fetch() {
                this.list = (await this.axios.get(`/delivery-address-redirects/${this.entityType}/${this.entityId}`)).data;
            },

            add() {
                this.list.push({
                    entity_type: this.entityType,
                    entity_id: this.entityId,
                    address_id_from: null,
                    address_id_to: null,
                    enabled: true
                });
            },

            remove(index) {
                if(this.list[index].id) {
                    this.deleted.push(this.list[index].id);
                }
                this.list.splice(index, 1);
            },

            async save() {
                this.isPending = true;
                
                try {
                    for(const id of this.deleted) {
                        await this.axios.delete(`/delivery-address-redirect/${id}`);
                    }
                    for(const item of this.list) {
                        if(item.id) {
                            await this.axios.put(`/delivery-address-redirect/${item.id}`, item);
                        } else {
                            await this.axios.post('/delivery-address-redirect', item);
                        }                            
                    }
                    await this.fetch();
                } catch (error) {
                    this.$root.$emit('showError', 'Не удалось сохранить настройки перенаправлений. ' + error);
                }

                this.isPending = false;
            },
        }
    }
</script>
